import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MembershipShopSteps, ShopMembership } from 'types';

export type MembershipsStore = {
  isLoading: boolean;
  errorMsg: string;
  step: MembershipShopSteps;
  isBackVisible: boolean;
  selectedMembership: ShopMembership | null;
  selectedCreditCardId: number | null;
  ottToken: string | null;
};

const initialState: MembershipsStore = {
  isLoading: false,
  errorMsg: '',
  step: MembershipShopSteps.LIST,
  isBackVisible: false,
  selectedMembership: null,
  selectedCreditCardId: null,
  ottToken: null
};

export const membershipsSlice = createSlice({
  name: 'packages',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStep: (state, action: PayloadAction<MembershipShopSteps>) => {
      state.step = action.payload;
    },
    setButtonVisible: (state, action: PayloadAction<boolean>) => {
      state.isBackVisible = action.payload;
    },
    selectMembership: (state, action: PayloadAction<ShopMembership | null>) => {
      state.selectedMembership = action.payload;
    },
    selectCreditCardId: (state, action: PayloadAction<number | null>) => {
      state.selectedCreditCardId = action.payload;
    },
    setOttToken: (state, action: PayloadAction<string | null>) => {
      state.ottToken = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    resetForm: () => initialState
  }
});

export const {
  setIsLoading,
  setStep,
  selectMembership,
  selectCreditCardId,
  setOttToken,
  setError,
  resetForm,
  setButtonVisible
} = membershipsSlice.actions;

export default membershipsSlice.reducer;
